import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { ICustomerData } from '@epi-models/pages/Home';

export const USER_API_URL = `${config.apiHost}/api/user`;
export const IMPERSONATION_API_URL = `${config.apiHost}/api/admin-tool/impersonation/token`;

export const getDetails = (): Promise<ICustomerData> => {
  return get(`${USER_API_URL}/details`);
};

export const getImpersonationToken = (guid: string): Promise<any> => {
  return get(`${IMPERSONATION_API_URL}/${guid}`);
};
